import { Page, Container, ContentHeader } from 'components'
import { ChurnReasonForm } from './components'

import { routes } from 'Routes'

const ChurnReasonsNew = () => {
  const navigationsRoutes = [
    {
      text: 'Listagem',
      route: routes.churnReasons.all,
    },
  ]
  return (
    <Page title="Novo motivo de churn">
      <Container maxWidth={false}>
        <ContentHeader
          title="Novo motivo"
          menu="Motivos de churn"
          subtitle="Novo motivo de churn"
          menuNavigations={navigationsRoutes}
        />
        <ChurnReasonForm />
      </Container>
    </Page>
  )
}

export default ChurnReasonsNew
